import { ThunkDispatch } from '../../generalTypes';
import { thunkSetMinRoom } from '../scene/sceneThunks';
import { actionUpdateUserAgent } from './userAgentActions';

export const thunkUpdateUserAgent = () => (dispatch: ThunkDispatch) => {
  dispatch(actionUpdateUserAgent());
  dispatch(thunkSetMinRoom());
};
